import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

const LocaleInitializer: React.FC = () => {
  const router = useRouter();

  useEffect(() => {
    // Only run on the client side
    if (typeof window === 'undefined') return;

    // Get the current locale from the router
    const { locale } = router;

    // Set the NEXT_LOCALE cookie if locale exists and differs from the current cookie value
    if (locale) {
      const currentCookieLocale = Cookies.get('NEXT_LOCALE');
      if (currentCookieLocale !== locale) {
        Cookies.set('NEXT_LOCALE', locale, { expires: 365 });
      }
    }
  }, [router.locale]);

  // This component doesn't render anything
  return null;
};

export default LocaleInitializer;
